import PropTypes from 'prop-types'

import { Typography } from 'common/widgets'
import classNames from './styles.module.scss'


ExpiredPromoModal.propTypes = {
  text: PropTypes.string.isRequired,
}

export default function ExpiredPromoModal({ text }) {
  return (
    <div className={classNames.promoModal}>
      <Typography variant="h3">
        {text}
      </Typography>
    </div>
  )
}
